import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TFactoryConfigState } from './factory-config.models';

export const getFactoryConfigState = (state: TPlani8State) => state.factoryConfigInfo;

export const getFactoryEfficiencyConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.factoryEfficiencyConfig,
);

export const getEfficiencyLoader = createSelector(getFactoryConfigState, (state) => state.showEfficiencyLoader);

export const getFactoryBenchmarkingConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.factoryBenchmarkingConfig,
);

export const getBenchmarkingLoader = createSelector(getFactoryConfigState, (state) => state.showBenchmarkingLoader);

export const getFactoryOtlOplConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.factoryOtlOplConfig,
);

export const getOtlOplLoader = createSelector(getFactoryConfigState, (state) => state.showOtlOplLoader);

export const getFactorySedConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.factorySedConfig,
);

export const getSedLoader = createSelector(getFactoryConfigState, (state) => state.showSedLoader);

export const getFactoryExpectedDateConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.factoryExpectedDateConfig,
);

export const getTnaTargetUpdatesConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.tnaTargetUpdatesConfig,
);

export const getExpectedDateLoader = createSelector(getFactoryConfigState, (state) => state.showExpectedDateLoader);
export const getTnaTargetUpdatesConfigLoader = createSelector(
  getFactoryConfigState,
  (state) => state.showTnaTargetUpdatesConfigLoader,
);

export const getAutoPlanConfig = createSelector(
  getFactoryConfigState,
  (state: TFactoryConfigState) => state.autoPlanConfig,
);

export const getAutoPlanConfigLoader = createSelector(getFactoryConfigState, (state) => state.showAutoPlanConfigLoader);
